import axios from 'api/axios'
import { ClientWhatsAppDetails } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for editSingleClientProfile
 */

export interface EditClientWhatsAppDetailsBody extends ClientWhatsAppDetails {}

/**
 * Type Interface for the Response object you get from editSingleClientProfile request if successful
 */
export interface EditClientWhatsAppDetailsResponse {
	statusCode: number
	message: string
}

/**
 * API call edit a Clients
 * @param body editClientBody - data to be send to backend for edit client
 * @returns AdminResponse - Response object returned from the server
 */

export const editClientProfile = async (
	id: string,
	body: EditClientWhatsAppDetailsBody
) => {
	try {
		const { data } = await axios.put<EditClientWhatsAppDetailsResponse>(
			`v1/wa/profile/${id}`,
			{
				...body,
				profile_image: body.profile_picture_url,
			}
		)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default editClientProfile
